// src/iframe.js
export function mountIframe(host, { src, token, config }) {
  const f = document.createElement('iframe');
  // allow-top-navigation is required so Worldpay's 3-D Secure / redirect-based
  // result flow can navigate the host page to book.attraxion.app/success (the
  // PaymentResult page). Without it the browser blocks the redirect and the
  // customer is stranded on the payment step. The framed content is our own
  // trusted origin, so granting top navigation is safe.
  f.setAttribute('sandbox', 'allow-scripts allow-forms allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-top-navigation');
  f.setAttribute('allow', 'payment');
  f.setAttribute('title', 'Booking');
  f.src = src;

  const targetOrigin = new URL(src).origin;
  const initMessage = {
    type: 'attraxion:init',
    token,
    config,
    origin: window.location.origin,
  };

  const postInit = () => {
    try { f.contentWindow?.postMessage(initMessage, targetOrigin); } catch {}
  };

  // Fast path: post when the iframe document loads.
  f.addEventListener('load', postInit);

  // Race fallback: if React mounts after `load` fires, the EmbedShell's
  // message listener won't be attached yet and the init message will be lost.
  // The embed sends `attraxion:ready` once its listener is up — re-post on that.
  window.addEventListener('message', (e) => {
    if (e.source === f.contentWindow && e.data?.type === 'attraxion:ready') {
      postInit();
    }
  });

  host.appendChild(f);
  return f;
}
